export default "__VITE_ASSET__42470495__"